import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import ViewAllButton from '../home/course-section/ViewAllButton';
import getDailySubjectiveQuestionList from '../../gql/queries/daily-subjective-question-list.gql';
import ErrorMessage from '../shared/error-fetching';
import HorizontalScroll from '../shared/HorizontalScroll';
import QuestionCard from './question-card';
import NoDataFound from '../shared/NoDataFound';

function DailySubjectiveHome({ contentHeading, listLimit }) {
  const {
    // eslint-disable-next-line no-unused-vars
    loading,
    error,
    data,
  } = useQuery(getDailySubjectiveQuestionList, {
    variables: {
      pageState: 1,
      pageLimit: Number(listLimit),
    },
  });
  // const questionList = data?.getDailySubjectiveQuestionList?.dailySubjectiveQuestions;
  if (error) return <ErrorMessage fullPage />;
  //   if (loading) return <Spinner fullPage />;
  return (
    <div className="pt-[34px] lg:pt-[52px]">
      <div className="flex justify-between mb-[18px] lg:mb-7 items-center pr-5 lg:pr-0">
        <h2 className="xl:text-2xl text-lg font-semibold">
          {contentHeading}
        </h2>
        <div className="mb-6 lg:mb-0">
          <ViewAllButton
            pageUrl="/daily-subjective-all-questions"
            typeButton={2}
          />
        </div>
      </div>
      <div className="mb-0">
        {
                data?.getDailySubjectiveQuestionList?.dailySubjectiveQuestions?.length > 0 ? (

                  <>
                    <HorizontalScroll>
                      <div
                        className="flex lg:gap-6 gap-4 h-full lg:p-0 p-1"
                      >
                        {data?.getDailySubjectiveQuestionList?.dailySubjectiveQuestions?.map((course, index) => (
                          <QuestionCard
                            key={course.id}
                            index={index}
                            questionList={course}
                            pageType="Home"
                          />
                        ))}
                      </div>
                    </HorizontalScroll>
                    <div className="lg:hidden mt-8">
                      <ViewAllButton
                        pageUrl="/daily-subjective-all-questions"
                      />
                    </div>
                  </>
                ) : (
                  <NoDataFound noMsg="No Data Found!" />
                )
}

      </div>
    </div>

  );
}

DailySubjectiveHome.propTypes = {
  contentHeading: PropTypes.any,
  listLimit: PropTypes.any,
};

export default DailySubjectiveHome;
